const getIsUnderMaintenance = (underMaintenanceInfo = {}) => {
    const { desktop, mobile } = underMaintenanceInfo;
    return !!(desktop?.isUnderMaintenance && mobile?.isUnderMaintenance);
};

export default getIsUnderMaintenance;
